module.exports = __webpack_public_path__ + "img/24.a902cde7.jpg";